module.exports = __webpack_public_path__ + "img/grugiallo.baf6964a.png";